import ReactDOM from 'react-dom';
import CalendarPlus from './CalendarPlus';

const container = document.getElementById('calendar-plus');
if (container !== null) {
	ReactDOM.render(<CalendarPlus />, container);
}
